  const formatCO2 = (value) => {
    if (!value || isNaN(value)) return "0";

    const num = Number(value);

    if (num >= 1e6) return (num / 1e6).toFixed(2) + " ktonnes";     // kilotonnes
    if (num >= 1e3) return (num / 1e3).toFixed(2) + " tonnes";      // tonnes

    return num.toFixed(2) + " kg";
  };

    const formatEnergy = (value) => {
    if (!value || isNaN(value)) return "0";
    const num = Number(value);
    if (num >= 1_000_000_000) return (num / 1_000_000_000).toFixed(2) + " GWh";
    if (num >= 1_000_000) return (num / 1_000_000).toFixed(2) + " MWh";
    return (num / 1_000).toFixed(3) + " kWh";
  };


export { formatCO2, formatEnergy };